import React from 'react';
import PropTypes from 'prop-types';

import { List } from 'semantic-ui-react';

const PolicyListItem = ({ icon, nickName, policyNumber, onClick, data, active, type, effective, expiration, status }) => {
	return (
		<List.Item style={{minHeight: '50px'}} id={`policy_${policyNumber}_btn`} onClick={onClick} data={data}>
			<List.Icon name={icon} size='large' verticalAlign='middle' style={{ flex: '0 0 auto', display: 'flex' }} />
			<List.Content style={{ display: 'flex', flexDirection: 'column', flex: '1 1 auto' }}>
				<List.Header as='a'>{nickName} </List.Header>
				<List.Description as='a'>
					<div>
						<b>Policy #</b> {policyNumber}
					</div>
					{type && (
						<div>
							<b>Type:</b> {type}
						</div>
					)}
					{status && (
						<div>
							<b>Status:</b> {status}
						</div>
					)}
					{effective && (
						<div>
							<b>Effective:</b> {effective}
						</div>
					)}

					{expiration && (
						<div>
							<b>Expiration:</b> {expiration}
						</div>
					)}
				</List.Description>
			</List.Content>
			{active ? <List.Icon name='chevron right' size='large' verticalAlign='middle' style={{ flex: '0 0 auto', display: 'flex' }} /> : null}
		</List.Item>
	);
};

PolicyListItem.propTypes = {
	icon: PropTypes.string.isRequired,
	nickName: PropTypes.string.isRequired,
	policyNumber: PropTypes.string.isRequired,
	active: PropTypes.bool.isRequired,
	onClick: PropTypes.func,
	data: PropTypes.object.isRequired,
	type: PropTypes.string.isRequired,
	effectiveStart: PropTypes.string,
	effectiveEnd: PropTypes.string,
	status: PropTypes.string.isRequired,
};

export default PolicyListItem;
